import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphMedium } from "baseui/typography";
import React from "react";
import { DocsInterface, type DocsInterfaceProps } from "../../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../../src/components/SplashPage";
import { Callout, DocLink, InlineCode } from "../../../../../src/markdown-components";

const AIAssistantLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>AI assistant</HeadingXLarge>
        <ParagraphMedium
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale400,
          }}
        >
          The Gadget AI assistant is a custom-trained LLM that specializes in Gadget&apos;s framework, features, and best practices. It aims
          to help you finish your projects quickly by teaching you Gadget and helping you across every part of the development experience:
          data modeling, sample data generation, code generation, debugging, and general Q&A.
        </ParagraphMedium>
        <ParagraphMedium
          $style={{
            paddingTop: $theme.sizing.scale400,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          The assistant is found in the Gadget editor and accessed through the assistant icon in the top right corner. It will remain open
          as a resizable sidebar while navigating throughout your app. You can customize the agent settings through the gear icon in the top
          right, and start a new chat and access chat history through the buttons in the top left.
        </ParagraphMedium>
        <Callout>
          <ParagraphMedium
            $style={{
              paddingBottom: $theme.sizing.scale600,
            }}
          >
            You can use <DocLink href="https://gadget.dev/llms.txt">https://gadget.dev/llms.txt</DocLink> to provide Gadget-specific context
            to local AI codegen tools and agents, such as Claude Code, Cursor, or VSCode + Copilot.
          </ParagraphMedium>
        </Callout>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Features"
            color={colors.white}
            body="Learn about the unique capabilities of the Gadget assistant."
            href="/guides/development-tools/ai-assistant/features"
            copy="See the features →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default AIAssistantLandingPage;
